export const aiProduct = {
  name: 'Stream',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Optimize your work across Sitecore with AI-enhanced workflows, Generative Copilots and Brand Aware AI.',

  link: {
    type: 'external-link',
    to: '{baseUrl}?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: '$.annotations.URL',
          resource: 'tenant',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  icon: {
    type: 'url',
    src: 'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/mark-symphony',
  },
  color: 'red',
};
